'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdControlPointDuplicate = function MdControlPointDuplicate(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 31.6q4.8 0 8.2-3.4t3.4-8.2-3.4-8.2-8.2-3.4-8.2 3.4-3.4 8.2 3.4 8.2 8.2 3.4z m0-26.6q6.3 0 10.6 4.4t4.4 10.6-4.4 10.6-10.6 4.4-10.6-4.4-4.4-10.6 4.4-10.6 10.6-4.4z m-21.6 15q0 3.4 1.8 6.3t4.8 4.2v3.6q-4.4-1.5-7.2-5.4t-2.8-8.7 2.8-8.7 7.2-5.4v3.5q-3 1.5-4.8 4.3t-1.8 6.3z m23.2-6.6v5h5v3.2h-5v5h-3.2v-5h-5v-3.2h5v-5h3.2z' })
        )
    );
};

exports.default = MdControlPointDuplicate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/control-point-duplicate.js
// module id = 3207
// module chunks = 168707334958949